module.exports = __webpack_public_path__ + "img/moon-of-appalacia.fcd79d41.jpg";